import { yupResolver } from '@hookform/resolvers'
import theme from '@ifca-root/react-component/src/assets/theme'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { PhoneNumInput } from '@ifca-root/react-component/src/components/Input/PhoneNumInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  TextField,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CreateIcon from '@material-ui/icons/Create'
import DeleteIcon from '@material-ui/icons/Delete'
import EmailIcon from '@material-ui/icons/Email'
import PhoneIcon from '@material-ui/icons/Phone'
import { Autocomplete } from '@material-ui/lab'
import irbmLogo from 'assets/einvoice/einvoice-irbm-logo.svg'
import { AddressAutoComponent } from 'components/AddressAutocomplete/AddressComponent'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { AccCodeDropdownFullWidth } from 'components/Dropdown/AccCodeDropdown'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  CreditorStatus,
  CreditorType,
  EInvoiceType,
  GetCreditorAccountDocument,
  useCheckInvalidTinNoLazyQuery,
  useCreateCreditorAccountMutation,
  useGetClassificationCodeQuery,
  useGetCreditorAccountCompanyNameLazyQuery,
  useGetCreditorTypeQuery,
  useGetLocalBankQuery,
  useGetMsicCodeQuery,
  useUpdateCreditorAccountWithItemMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { useAddressAutoComplete } from 'helpers/Hooks/useAddressAutoComplete'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { amtNumStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router'
import * as yup from 'yup'

interface CreditorProfileProps {
  companyRegNo: string
  companyName: string
  taxIdentificationNo: string
  creditorType: string
  phoneNo: number
  email: string
  creditTerms: string
  region: string
  SWIFTCode: any
  PayeeName: string
  GSTRegNo: string
  SSTRegNo: string
  remark: string
  bankAccNo: string
  bankName: string
  Contact: any
  Director: any
  ClassificationCodeID: string
  MSICCodeID: string
  isForeignSupplier: boolean
  isSelfBilled: boolean
  isDirectSend: boolean
  isCompany: boolean
  EInvoiceType: string
}

export const CreditorProfileForm = (props: any) => {
  const { mode, page }: any = props
  const { creditorType, CreditorAccountID, CompanyID }: any = useParams()
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [country, setCountry] = useState('')
  const [states, setStates] = useState('')
  const [city, setCity] = useState('')
  const [postcode, setPostcode] = useState('')
  const { menu, handleClick, resetMenu } = useMenuOption()
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [openDirectorDialog, setOpenDirectorDialog] = useState<boolean>(false)
  const [contactData, setContactData] = useState([])
  const [directorData, setDirectorData] = useState([])
  const [checkContactError, setCheckContactError] = useState([])
  const [checkDirectorError, setCheckDirectorError] = useState([])
  const [openExitConf, setOpenExitConf] = useState(null)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [isChecked, setIsChecked] = useState(false)
  const [errorDia, setErrorDia] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [tinNo, setTinNo] = useState('')

  let location = useLocation()
  const editData = location?.state as any

  const eInvoiceSubscriber = JSON.parse(
    localStorage.getItem('eInvoiceSubscriber')
  )
  //e-invoice setup for transaction
  const [isSelfBilled, setIsSelfBilled] = useState(
    editData ? editData?.einvoice_self_billed : false
  )
  const [isDirectSend, setIsDirectSend] = useState(
    editData ? editData?.einvoice_send_individually : false
  )

  const CreditorProfileSchema = yup.object().shape({
    companyRegNo: yup.string().when('EInvoiceType', {
      is: einvoiceType =>
        [EInvoiceType.Individual, EInvoiceType.Foreigner].includes(
          einvoiceType
        ),
      then: yup.string().required('ID/Passport No. is required'),
      otherwise: yup.string().required('Company Registration No. is required'),
    }),
    phoneNo: CommonYupValidation.requireField(SystemMsgs.phoneNo()),
    creditorType: CommonYupValidation.requireField(SystemMsgs.creditorType()),
    companyName: CommonYupValidation.requireField(SystemMsgs.companyName()),
    creditTerms: CommonYupValidation.requireField(SystemMsgs.creditTerms()),
    PayeeName: yup.string().required('Payee Name is required'),
    ...(isSelfBilled && isDirectSend
      ? {
          taxIdentificationNo: CommonYupValidation.requireField(
            SystemMsgs.taxIdentificationNo()
          ),
        }
      : null),

    ...(isSelfBilled
      ? { SSTRegNo: CommonYupValidation.requireField(SystemMsgs.SSTRegNo()) }
      : null),
    ...(isSelfBilled
      ? {
          ClassificationCodeID: yup.string().when('isSelfBilled', {
            is: true,
            then: yup
              .string()
              .required(SystemMsgs.ClassificationCode())
              .nullable(),
            otherwise: null,
          }),
        }
      : null),
    ...(isSelfBilled
      ? {
          MSICCodeID: yup.string().when('isSelfBilled', {
            is: true,
            then: yup
              .string()
              .required(SystemMsgs?.MSICCode())
              .nullable(),
            otherwise: null,
          }),
        }
      : null),
  })

  let typeOfCreditor = type => {
    let temp
    switch (type) {
      case 'supplier':
        temp = CreditorType.Supplier
        break
      case 'contractor':
        temp = CreditorType.Contractor
        break
      case 'consultant':
        temp = CreditorType.Consultant
        break
      case 'agent':
        temp = CreditorType.Agent
        break
      case 'other':
        temp = CreditorType.Other
        break
    }
    return temp
  }

  let creditorName = type => {
    let temp
    switch (type) {
      case 'supplier':
        temp = 'Supplier'
        break
      case 'contractor':
        temp = 'Contractor'
        break
      case 'consultant':
        temp = 'Consultant'
        break
      case 'agent':
        temp = 'Agent'
        break
      case 'other':
        temp = 'Other'
        break
    }
    return temp
  }

  const {
    handleSubmit,
    register,
    errors,
    control,
    watch,
    clearErrors,
    setValue,
    formState: { isSubmitted, isDirty },
  } = useForm<CreditorProfileProps>({
    defaultValues: {
      EInvoiceType: editData ? editData?.einvoice_type : EInvoiceType.Company,
      isCompany: editData ? editData?.IsCompany : '',
      taxIdentificationNo: editData ? editData?.einvoice_TIN : '',
    },

    mode: 'onSubmit',
    resolver: yupResolver(CreditorProfileSchema),
  })

  useEffect(() => {
    if (mode === 'edit' && editData) {
      const Contact = Array.isArray(editData.CreditorContact)
        ? editData.CreditorContact?.map((el, index) => {
            return {
              name: el?.Name,
              phoneNo: el?.ContactNo,
              email: el?.Email,
              designation: el?.Designation,
              isDefault: el?.IsDefault,
            }
          })
        : []
      const Director = Array.isArray(editData.CreditorDirector)
        ? editData.CreditorDirector?.map((el, index) => {
            return {
              identityNo: el?.IdentityNo,
              identityType: el?.IdentityType,
              name: el?.Name,
              phoneNo: el?.ContactNo,
              email: el?.Email,
            }
          })
        : []

      contactData.push(...Contact)
      directorData.push(...Director)

      let array_of_address = [editData?.Address?.address]
      setQuery(array_of_address.join(', '))
      initializeEditValue({
        address: array_of_address.join(', '),
        country: editData?.Address?.country,
        state: editData?.Address?.state,
        city: editData?.Address?.city,
        postCode: editData?.Address?.postCode,
      })
      register('isForeignSupplier')
      register('isSelfBilled')
      register('EInvoiceType')
      register('isCompany')
      setValue('isForeignSupplier', editData?.einvoice_foreign_supplier)
      setValue('isSelfBilled', editData?.einvoice_self_billed)
      setIsSelfBilled(editData?.einvoice_self_billed)
      setIsDirectSend(editData?.einvoice_send_individually)
      setValue('EInvoiceType', editData?.einvoice_type)
      setValue('isCompany', editData?.IsCompany)
      setTinNo(editData?.einvoice_TIN)
    }
  }, [mode, editData])

  const {
    getCountry, // country
    getStatebyCountry, // State
    getCitybyState, // City
    getPostcodebyCity, // Postcode
    handleCountryOnChange,
    handleStateOnChange,
    handleCityOnChange,
    handlePostCodeOnChange,
    handleGoogleOnChange,
    query,
    autoCompleteRef,
    state,
    setQuery,
    initializeEditValue,
  } = useAddressAutoComplete()

  const [
    loadCompanyName,
    {
      loading: creditorLoading,
      data: { getCreditorAccount } = {
        getCreditorAccount: [],
      },
    },
  ] = useGetCreditorAccountCompanyNameLazyQuery({
    fetchPolicy: 'network-only',
  })

  const {
    loading: creditorTypeLoading,
    data: { getCreditorType } = { getCreditorType: [] },
  } = useGetCreditorTypeQuery({
    fetchPolicy: 'network-only',
    variables: {
      CreditorType: typeOfCreditor(creditorType),
      CreditorAccountID: editData?.CreditorAccountID,
    },
  })

  const {
    loading: localBankLoading,
    data: { getLocalBank } = { getLocalBank: [] },
  } = useGetLocalBankQuery({
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
    variables: { orderByAsc: 'name' },
  })

  const {
    loading: msicCodeLoading,
    data: { getMSICCode } = { getMSICCode: [] },
  } = useGetMsicCodeQuery({
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
    fetchPolicy: 'network-only',
  })

  const {
    loading: ClassificationCodeLoading,
    data: { getClassificationCode } = { getClassificationCode: [] },
  } = useGetClassificationCodeQuery({
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
    fetchPolicy: 'network-only',
  })

  const [
    createCreditorAccount,
    { loading: createLoading },
  ] = useCreateCreditorAccountMutation({
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        if (page === 'creditor-profile') {
          history.push({
            pathname: `/account-payable/general-setting/creditor-profile/supplier/${data?.CreateCreditorAccount?.CreditorAccountID}/assign`,
            state: { success: true, msgMode: 'create' },
          })
        } else {
          history.push({
            pathname: `/account-payable/${CompanyID}/creditor-account/creditor-profile/${CreditorAccountID}/detail`,
            state: { success: true, msgMode: 'create' },
          })
        }
      }, 500)
    },
  })

  const [
    updateCreditorAccount,
    { loading: updateLoading, error: updateError },
  ] = useUpdateCreditorAccountWithItemMutation({
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setTimeout(() => {
        if (page === 'creditor-profile') {
          history.push({
            pathname: `/account-payable/general-setting/creditor-profile/${creditorType}/${CreditorAccountID}/detail`,
            state: { success: true, msgMode: 'update' },
          })
        } else {
          history.push({
            pathname: `/account-payable/${CompanyID}/creditor-account/creditor-profile/${CreditorAccountID}/detail`,
            state: { success: true, msgMode: 'update' },
          })
        }
      }, 500)
    },
  })
  const [
    getCheckInvalid,
    {
      loading: checkInvalidTinNoLoading,
      error: checkInvalidTinNoError,
      data: { checkInvalidTinNo } = { checkInvalidTinNo: false },
    },
  ] = useCheckInvalidTinNoLazyQuery({
    onCompleted: ({ checkInvalidTinNo }) => {
      if (checkInvalidTinNo) setIsChecked(false)
    },
    onError: e => {
      let error = e.message.substring(15)
      setErrorDia(true)
      setErrMsg(error)
      setIsChecked(false)
    },
  })

  const handleCheckInvalid = event => {
    setIsChecked(event.target.checked)
    getCheckInvalid({
      variables: {
        tinNo: watch('taxIdentificationNo'),
        identityNo: watch('companyRegNo'),
        identityType: 'BUSINESS_LICENSE',
      },
    })
  }

  const isInvalid = checkInvalidTinNo

  const IdentityType = [
    { type: 'IDENTITY_CARD', name: 'Identity Card' },
    { type: 'MILITARY_CARD', name: 'Military Card' },
    { type: 'PASSPORT', name: 'Passport' },
    { type: 'BUSINESS_LICENSE', name: 'Business License' },
  ]

  const einvoiceType = [
    { name: 'Individual', type: EInvoiceType.Individual },
    { name: 'Company', type: EInvoiceType.Company },
    { name: 'Foreign Supplier', type: EInvoiceType.Foreigner },
  ]

  const onCreateContact = data => {
    if (checkContact(watch('Contact'))?.length === 0) {
      contactData.push({
        name: data.contactName,
        phoneNo: data.mobileNo,
        email: data.emailAddress,
        designation: data.designation,
        isDefault: data.isDefault,
      })
    }
  }
  const onUpdateContact = (data, index) => {
    if (checkContact(watch('Contact'))?.length === 0) {
      contactData[index].name = data.contactName
      contactData[index].phoneNo = data.mobileNo
      contactData[index].email = data.emailAddress
      contactData[index].designation = data.designation
      contactData[index].isDefault = data.isDefault
    }
  }
  const onDeleteContact = index => {
    contactData.splice(index, 1)
  }
  const onCreateDirector = data => {
    if (checkDirector(watch('Director'))?.length === 0) {
      directorData.push({
        identityNo: data.identityNo,
        identityType: data.identityType,
        name: data.contactName,
        phoneNo: data.mobileNo,
        email: data.emailAddress,
      })
    }
  }
  const onDeleteDirector = index => {
    directorData.splice(index, 1)
  }

  const onUpdateDirector = (index, data) => {
    if (checkDirector(watch('Director'))?.length === 0) {
      directorData[index].identityNo = data.identityNo
      directorData[index].identityType = data.identityType
      directorData[index].name = data.contactName
      directorData[index].phoneNo = data.mobileNo
      directorData[index].email = data.emailAddress
    }
  }

  const onSubmit = (data, state, contact, director) => {
    if (
      state.address
      // ====== Below commented to allow free text address ======
      // state.country.name &&
      // state.state.name &&
      // state.city.name &&
      // state.postcode.postcode
    ) {
      if (mode === 'add') {
        createCreditorAccount({
          variables: {
            input: {
              ...(isSelfBilled
                ? {
                    einvoice_send_individually: data?.isDirectSend,
                    einvoice_TIN: data?.taxIdentificationNo,
                    einvoice_msic_code_id: data?.MSICCodeID,
                    einvoice_classification_code_id: data?.ClassificationCodeID,
                    einvoice_foreign_supplier:
                      data?.EInvoiceType === 'FOREIGNER' ? true : false,
                    einvoice_self_billed: isSelfBilled,
                  }
                : null),
              einvoice_type: data?.EInvoiceType,
              CreditorTypeID: data?.creditorType,
              CompanyRegNo: data?.companyRegNo,
              // TaxIdentificationNo: data?.taxIdentificationNo,
              IsCompany: data?.EInvoiceType === 'COMPANY' ? true : false,
              ContactNo: data?.phoneNo,
              CompanyName: data?.companyName,
              Email:
                data?.email === '' || data?.email === null ? null : data?.email,
              Address: {
                address: state.address,
                state: states ?? state.state.name ?? '',
                city: city ?? state.city.name ?? '',
                country: country ?? state.country.name ?? '',
                postCode: postcode ?? state.postcode.postcode ?? '',
              },
              CreditTerm: parseFloat(amtNumStr(data?.creditTerms)),
              Region: data?.region,
              GSTRegNo: data?.GSTRegNo,
              SSTRegNo: data?.SSTRegNo,
              Remark: data?.remark,
              BankName: data?.bankName,
              SWIFTCode: data?.SWIFTCode,
              PayeeName: data?.PayeeName,
              BankAccountNo: data?.bankAccNo,
              CreditorTypeEnum: getCreditorType?.find(
                x => x?.CreditorTypeID === data?.creditorType
              ).CreditorType,
              CreditorStatus: CreditorStatus.Active,
            },
            contactItem: contact?.map(y => {
              return {
                Name: y?.name,
                ContactNo: y?.phoneNo,
                Designation: y?.designation,
                Email: y?.email,
              }
            }),
            directorItem: director?.map(y => {
              return {
                IdentityNo: y?.identityNo,
                IdentityType: y?.identityType,
                Name: y?.name,
                ContactNo: y?.phoneNo,
                Email: y?.email,
              }
            }),
          },
          refetchQueries: [{ query: GetCreditorAccountDocument }],
        })
      } else if (mode === 'edit') {
        updateCreditorAccount({
          variables: {
            input: {
              CreditorAccountID: CreditorAccountID,
              CreditorTypeID: data?.creditorType,
              CompanyRegNo: data?.companyRegNo,
              einvoice_self_billed: isSelfBilled,
              einvoice_send_individually: data?.isDirectSend,
              einvoice_TIN: data?.taxIdentificationNo,
              einvoice_msic_code_id:
                data?.MSICCodeID === undefined ? null : data?.MSICCodeID,
              einvoice_classification_code_id:
                data?.ClassificationCodeID === undefined
                  ? null
                  : data?.ClassificationCodeID,
              einvoice_foreign_supplier:
                data?.EInvoiceType === 'FOREIGNER' ? true : false,
              einvoice_type: data?.EInvoiceType,
              IsCompany: data?.isCompany,
              ContactNo: data?.phoneNo,
              CompanyName: data?.companyName,
              Email:
                data?.email === '' || data?.email === null ? null : data?.email,
              Address: {
                address: state.address,
                state: states ?? state.state.name ?? '',
                city: city ?? state.city.name ?? '',
                country: country ?? state.country.name ?? '',
                postCode: postcode ?? state.postcode.postcode ?? '',
              },
              CreditTerm: parseFloat(amtNumStr(data?.creditTerms)),
              Region: data?.region,
              GSTRegNo: data?.GSTRegNo,
              SSTRegNo: data?.SSTRegNo,
              Remark: data?.remark,
              BankName: data?.bankName,
              BankAccountNo: data?.bankAccNo,
              SWIFTCode: data?.SWIFTCode,
              PayeeName: data?.PayeeName,
              CreditorTypeEnum: getCreditorType?.find(
                x => x?.CreditorTypeID === data?.creditorType
              ).CreditorType,
              CreditorStatus: CreditorStatus.Active,
            },
            contactItem: contact?.map(y => {
              return {
                Name: y?.name,
                ContactNo: y?.phoneNo,
                Designation: y?.designation,
                Email: y?.email,
              }
            }),
            directorItem: director?.map(y => {
              return {
                IdentityNo: y?.identityNo,
                IdentityType: y?.identityType,
                Name: y?.name,
                ContactNo: y?.phoneNo,
                Email: y?.email,
              }
            }),
          },
          refetchQueries: [
            {
              query: GetCreditorAccountDocument,
              variables: { CreditorAccountID: CreditorAccountID },
            },
          ],
        })
      }
    }
  }

  /* ------------------------------ */
  /*           FUNCTION             */
  /* ------------------------------ */
  const checkContact = data => {
    let errorData = []
    if (data.contactName === undefined || data.contactName === '') {
      errorData.push({
        error: 'contactName',
      })
    }
    if (data.designation === undefined || data.designation === '') {
      errorData.push({
        error: 'designation',
      })
    }
    if (!!data?.isDefault === true) {
      const checkedContact = contactData?.map(v => {
        if (v?.phoneNo === watch('Contact').mobileNo) {
          return { ...v, isDefault: true }
        } else {
          return { ...v, isDefault: false }
        }
      })
      setContactData(checkedContact)
    }
    setCheckContactError(errorData)
    return errorData
  }

  const checkDirector = data => {
    let errorData = []
    setCheckDirectorError(errorData)
    return errorData
  }

  const validateEmail = email => {
    if (email === null || email === '' || email === undefined) {
      return true
    } else {
      if (
        email?.match(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      ) {
        return true
      } else {
        return false
      }
    }
  }

  const handleCheckBox = (e, name) => {
    setValue(name, e.target.checked)
    setIsSelfBilled(e.target.checked)
    clearErrors('ClassificationCodeID')
    clearErrors('MSICCodeID')
  }

  const handleIsDirectCheckBox = (e, name) => {
    setValue(name, e.target.checked)
    setIsDirectSend(e.target.checked)
    if (!!watch('EInvoiceType') && watch('EInvoiceType') === 'FOREIGNER') {
      register('taxIdentificationNo')
      setValue('taxIdentificationNo', 'EI00000000030')
      setTinNo('EI00000000030')
    }
    if (!!watch('EInvoiceType') && watch('EInvoiceType') === 'INDIVIDUAL') {
      register('taxIdentificationNo')
      setValue('taxIdentificationNo', 'EI00000000010')
      setTinNo('EI00000000010')
    }
  }

  const handleChange = e => {
    setValue('EInvoiceType', e?.target?.value)
    if (e?.target?.value === 'FOREIGNER') {
      register('isSelfBilled')
      setValue('isSelfBilled', true)
      register('isDirectSend')
      setValue('isDirectSend', true)
      setIsDirectSend(true)
      setIsSelfBilled(true)
      register('taxIdentificationNo')
      setValue('taxIdentificationNo', 'EI00000000030')
      setTinNo('EI00000000030')
    } else if (e?.target?.value === 'INDIVIDUAL') {
      setValue('isSelfBilled', false)
      setIsSelfBilled(false)
      setValue('taxIdentificationNo', 'EI00000000010')
      setTinNo('EI00000000010')
    } else {
      setValue('isSelfBilled', false)
      setIsSelfBilled(false)
      setValue('taxIdentificationNo', '')
      setTinNo('')
    }
  }

  const checkbox = (checkedCondition: boolean, name: string, label: string) => {
    return (
      <Controller
        as={
          <FormControlLabel
            style={{ fontWeight: 'bold' }}
            control={
              <Checkbox
                name={name}
                checked={checkedCondition === true ? true : false}
                color="primary"
                ref={register}
                onChange={e => {
                  name === 'isSelfBilled'
                    ? handleCheckBox(e, name)
                    : handleIsDirectCheckBox(e, name)
                }}
                disabled={
                  name === 'isSelfBilled' &&
                  watch('EInvoiceType') === 'FOREIGNER'
                }
              />
            }
            label={label}
          />
        }
        name={name}
        ref={register}
        control={control}
      />
    )
  }

  const checkDuplicateCompanyName = () => {
    const allCompany = getCreditorAccount.map(x =>
      x?.CompanyName.toLocaleLowerCase()
    )

    const currentCompany = !!watch('companyName')
      ? watch('companyName')
          .toLocaleLowerCase()
          .trim()
      : ''

    const editingCompanyName = editData?.CompanyName?.toLocaleLowerCase().trim()

    if (editingCompanyName && currentCompany === editingCompanyName) {
      return false
    }

    return allCompany.includes(currentCompany)
  }

  useEffect(() => {
    loadCompanyName()
  }, [])

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      formMode: mode,
    })

  return (
    <>
      {createLoading && <Loading />}
      {updateLoading && <Loading />}
      {creditorLoading && <Loading />}
      {localBankLoading && <Loading />}
      {creditorTypeLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : mode === 'add' && page === 'creditor-profile'
            ? history.push(
                `/account-payable/general-setting/creditor-profile/${creditorType}`
              )
            : mode !== 'add' && page === 'creditor-profile'
            ? history.push({
                pathname: `/account-payable/general-setting/creditor-profile/${creditorType}`,
              })
            : history.push(
                `/account-payable/${CompanyID}/creditor-account/creditor-profile/${CreditorAccountID}/detail`
              )
        }} //<- back button action
        smTitle={'Account Payable'}
        title={user?.accountName}
        routeSegments={[
          { name: 'General Setting' },
          { name: 'Creditor Profile' },
          { name: 'Creditor Profile', current: true },
        ]}
        rightRouteSegments={[
          { name: mode === 'add' ? 'New' : 'Edit', current: true },
        ]}
      />
      <ContentWrapper footer>
        <CardContents
          section={{
            header: {
              title:
                page === 'creditor-profile'
                  ? `${creditorName(creditorType)} Details`
                  : `Creditor Profile`,
            },
          }}
        >
          <Controller
            render={({ onChange, value }) => (
              <TextField
                margin="dense"
                label="Type"
                onChange={e => {
                  handleChange(e)
                }}
                defaultValue={
                  editData ? editData?.einvoice_type : EInvoiceType.Company
                }
                select
              >
                {einvoiceType?.map((x, index) => (
                  <MenuItem key={index} value={x?.type}>
                    <span className="text-noflow">{`${x?.name}`}</span>
                  </MenuItem>
                ))}
              </TextField>
            )}
            select
            name="EInvoiceType"
            autoComplete="off"
            control={control}
            fullWidth
            ref={register()}
          />

          <Controller
            render={({ onChange, value }) => (
              <TextField
                select
                name="creditorType"
                label="Creditor Type"
                onChange={e => {
                  setValue('creditorType', e?.target?.value)
                }}
                helperText={errors?.creditorType?.message}
                error={errors?.creditorType ? true : false}
                defaultValue={editData?.CreditorTypeID}
                required
                disabled={
                  getCreditorType?.filter(
                    x =>
                      x?.CreditorTypeID === editData?.CreditorTypeID &&
                      x?.IsUsed === true
                  )?.length > 0
                }
              >
                {getCreditorType
                  ?.sort((a, b) => {
                    return a?.Description?.localeCompare(b?.Description)
                  })
                  ?.map((el, index) => (
                    <MenuItem
                      key={index}
                      value={el.CreditorTypeID}
                      style={{ whiteSpace: 'normal' }}
                      disabled={el?.IsUsed}
                    >
                      <span className="text-noflow">{el.Description}</span>
                    </MenuItem>
                  ))}
              </TextField>
            )}
            onChange={e => {
              setValue('creditorType', e?.target?.value)
            }}
            name="creditorType"
            label="Creditor Type"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            ref={register}
            select
            defaultValue={editData?.CreditorTypeID}
            required
          />
          {!eInvoiceSubscriber && (
            <Controller
              as={TextField}
              id="standard-basic"
              name="taxIdentificationNo"
              label="TIN"
              // required
              autoComplete="off"
              control={control}
              fullWidth
              className="full"
              margin="dense"
              // helperText={errors?.taxIdentificationNo?.message}
              // error={errors?.taxIdentificationNo ? true : false}
              ref={register}
              defaultValue={editData?.TaxIdentificationNo}
            />
          )}

          <Controller
            style={{ textOverflow: 'ellipsis' }}
            as={TextField}
            id="standard-basic"
            name="companyRegNo"
            label={
              watch('EInvoiceType') === 'FOREIGNER' ||
              watch('EInvoiceType') === 'INDIVIDUAL'
                ? 'ID / Passport No.'
                : 'Company Registration No.'
            }
            defaultValue={editData?.CompanyRegNo}
            control={control}
            fullWidth
            margin="dense"
            helperText={
              (errors?.companyRegNo && watch('EInvoiceType') === 'FOREIGNER') ||
              (errors?.companyRegNo && watch('EInvoiceType') === 'INDIVIDUAL')
                ? 'ID/Passport No. is required'
                : errors?.companyRegNo
                ? 'Company Registration No. is required'
                : null
            }
            error={errors?.companyRegNo ? true : false}
            ref={register}
            InputLabelProps={{ style: {} }}
            required
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="companyName"
            label="Company Name"
            required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={
              errors?.companyName
                ? errors.companyName?.message
                : checkDuplicateCompanyName()
                ? 'Duplicate Company Name'
                : null
            }
            error={
              errors?.companyName || checkDuplicateCompanyName() ? true : false
            }
            ref={register}
            defaultValue={editData?.CompanyName}
          />

          <Controller
            as={
              <PhoneNumInput
                country={user?.countryCode ?? 'my'}
                specialLabel="Phone No. *"
                fullWidth
                required
              />
            }
            name="phoneNo"
            type="tel"
            marginTop
            marginBottom
            helperText={errors?.phoneNo?.message}
            error={errors?.phoneNo ? true : false}
            margin="dense"
            control={control}
            ref={register}
            defaultValue={editData?.ContactNo}
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="email"
            label="Email Address"
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={
              watch('email') === '' ||
              watch('email') === null ||
              watch('email') === undefined
                ? null
                : validateEmail(watch('email')) === false
                ? 'Email must be a valid email'
                : null
            }
            error={
              watch('email') === '' ||
              watch('email') === null ||
              watch('email') === undefined
                ? false
                : validateEmail(watch('email')) === false
                ? true
                : false
            }
            ref={register}
            defaultValue={
              editData?.Email === null ? undefined : editData?.Email
            }
          />

          <Controller
            as={
              <NumberFormat
                allowNegative={true}
                customInput={TextField}
                autoComplete="off"
                isNumericString
                label="Credit Terms"
                margin="dense"
              />
            }
            id="standard-basic"
            name="creditTerms"
            label="Credit Terms"
            required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={errors?.creditTerms?.message}
            error={errors?.creditTerms ? true : false}
            ref={register}
            defaultValue={editData?.CreditTerm}
            className="left"
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="region"
            label="Region"
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={editData?.Region}
            className="left"
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="GSTRegNo"
            label="GST Registration No."
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={editData?.GSTRegNo}
            className="left"
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="SSTRegNo"
            label="SST Registration No."
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            required={!!watch('isSelfBilled') ? true : false}
            helperText={
              errors?.SSTRegNo ? 'SST Registration No. is required' : null
            }
            error={errors?.SSTRegNo ? true : false}
            ref={register}
            defaultValue={editData?.SSTRegNo}
            className="right"
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="remark"
            label="Remark"
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={editData?.Remark}
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="bankAccNo"
            label="Bank Account No."
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            defaultValue={editData?.BankAccountNo}
            className="left"
          />

          <Controller
            render={({ onChange, value }) => (
              <TextField
                style={{ marginTop: '5px' }}
                select
                name="bankName"
                label="Bank Name"
                className="right"
                onChange={e => {
                  setValue('bankName', e?.target?.value)
                }}
                defaultValue={editData?.BankName}
              >
                {getLocalBank?.map((el, index) => (
                  <MenuItem key={index} value={el?.name}>
                    {`${el?.name} | ${el?.code}`}
                  </MenuItem>
                ))}
              </TextField>
            )}
            name="bankName"
            className="right"
            label="Bank Name"
            autoComplete="off"
            control={control}
            multiline={true}
            fullWidth
            ref={register}
            select
            onChange={e => {
              setValue('bankName', e?.target?.value)
            }}
            defaultValue={editData?.BankName}
          />

          <Controller
            as={TextField}
            name="SWIFTCode"
            label="SWIFT Code"
            autoComplete="off"
            className="left"
            margin="dense"
            multiline={true}
            fullWidth
            ref={register}
            control={control}
            defaultValue={editData?.SWIFTCode}
          ></Controller>

          <Controller
            as={TextField}
            id="standard-basic"
            name="PayeeName"
            label="Payee Name"
            autoComplete="off"
            className="right"
            control={control}
            fullWidth
            required
            margin="dense"
            ref={register}
            helperText={errors?.PayeeName ? 'Payee Name is required' : null}
            error={errors?.PayeeName ? true : false}
            defaultValue={editData?.PayeeName}
          />
        </CardContents>

        {eInvoiceSubscriber && (
          <CardContents
            section={{
              header: {
                title: 'e-Invoice Details',
              },
            }}
          >
            {/* Send e-Invoice individually */}

            <ListItem style={{ paddingLeft: '2px' }}>
              <Grid item>
                {checkbox(
                  watch('isSelfBilled') ?? editData?.einvoice_self_billed,
                  'isSelfBilled',
                  'Default Self-Billed'
                )}
              </Grid>
              {watch('isSelfBilled') && (
                <Grid item>
                  {checkbox(
                    watch('isDirectSend') ??
                      editData?.einvoice_send_individually,
                    'isDirectSend',
                    'Send e-Invoice Individually'
                  )}
                </Grid>
              )}
            </ListItem>

            {(editData?.einvoice_send_individually ||
              watch('isDirectSend')) && (
              <Controller
                as={TextField}
                fullWidth
                label="TIN"
                margin="dense"
                ref={register}
                autoComplete="off"
                name="taxIdentificationNo"
                required={
                  !!watch('isSelfBilled') && !!watch('isDirectSend')
                    ? true
                    : false
                }
                helperText={
                  !!watch('isSelfBilled') &&
                  !!watch('isDirectSend') &&
                  errors?.taxIdentificationNo
                    ? 'TIN is required'
                    : checkInvalidTinNo
                    ? 'Invalid TIN'
                    : ''
                }
                error={
                  (!!watch('isSelfBilled') &&
                    !!watch('isDirectSend') &&
                    errors?.taxIdentificationNo) ||
                  checkInvalidTinNo
                    ? true
                    : false
                }
                defaultValue={editData ? editData?.einvoice_TIN : tinNo}
                control={control}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        size="small"
                        variant="contained"
                        onClick={handleCheckInvalid}
                        color="primary"
                        disabled={checkInvalidTinNoLoading}
                        style={{ marginBottom: 10 }}
                      >
                        <img alt="" src={irbmLogo} />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            )}


            {!ClassificationCodeLoading && (
              <Controller
                render={({ value, onChange }) => {
                  let defVal = getClassificationCode?.filter(
                    coa => coa?.id === editData?.einvoice_classification_code_id
                  )[0]

                  return (
                    <Autocomplete
                      options={
                        watch('isSelfBilled')
                          ? getClassificationCode
                              ?.sort((a, b) => {
                                return a?.classificationCode.localeCompare(
                                  b?.classificationCode
                                )
                              })
                              ?.filter(x =>
                                x?.description.includes('Self-billed')
                              )
                          : getClassificationCode?.sort((a, b) => {
                              return a?.classificationCode.localeCompare(
                                b?.classificationCode
                              )
                            }) || []
                      }
                      getOptionLabel={option =>
                        `${option?.classificationCode} (${option?.description})`
                      }
                      fullWidth
                      onChange={(value, newValue: any) => {
                        onChange(newValue?.id)
                      }}
                      disabled={mode === 'approve-reject'}
                      PopperComponent={AccCodeDropdownFullWidth}
                      renderOption={(props, option) => {
                        return (
                          <div className="content-wrap full">
                            <div>
                              <span className="xsTitle">
                                {props?.classificationCode}
                              </span>
                            </div>
                            <div className="desc">{props?.description}</div>
                          </div>
                        )
                      }}
                      defaultValue={defVal}
                      renderInput={(params: any) => {
                        return (
                          <div>
                            <TextField
                              {...params}
                              helperText={
                                !!watch('isSelfBilled') &&
                                errors?.ClassificationCodeID
                                  ? 'Classification Code is required'
                                  : null
                              }
                              error={
                                !!watch('isSelfBilled') &&
                                errors?.ClassificationCodeID
                                  ? true
                                  : false
                              }
                              label="Classification Code"
                              style={{ width: '100%' }}
                              disabled={mode === 'approve-reject'}
                              InputLabelProps={defVal ? { shrink: true } : null}
                              margin="dense"
                              variant="standard"
                              required={!!watch('isSelfBilled') ? true : false}
                            />
                          </div>
                        )
                      }}
                    />
                  )
                }}
                label="Classification Code"
                name="ClassificationCodeID"
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                margin="dense"
                ref={register}
                helperText={
                  !!watch('isSelfBilled') && errors?.ClassificationCodeID
                    ? 'Classification Code is required'
                    : null
                }
                error={
                  !!watch('isSelfBilled') && errors?.ClassificationCodeID
                    ? true
                    : false
                }
                defaultValue={
                  editData ? editData?.einvoice_classification_code_id : ''
                }
              />
            )}

            {!msicCodeLoading && (
              <Controller
                render={({ value, onChange }) => {
                  let defVal = getMSICCode?.filter(
                    coa => coa?.id === editData?.einvoice_msic_code_id
                  )[0]

                  return (
                    <Autocomplete
                      options={
                        getMSICCode?.sort((a, b) => {
                          return a?.msicCode.localeCompare(b?.msicCode)
                        }) || []
                      }
                      getOptionLabel={option =>
                        `${option?.msicCode} (${option?.description})`
                      }
                      fullWidth
                      onChange={(value, newValue: any) => {
                        onChange(newValue?.id)
                      }}
                      PopperComponent={AccCodeDropdownFullWidth}
                      renderOption={(props, option) => {
                        return (
                          <div className="content-wrap full">
                            <div>
                              <span className="xsTitle">{props?.msicCode}</span>
                            </div>
                            <div className="desc">{props?.description}</div>
                          </div>
                        )
                      }}
                      defaultValue={defVal}
                      renderInput={(params: any) => {
                        return (
                          <div>
                            <TextField
                              {...params}
                              helperText={
                                !!watch('isSelfBilled') && errors?.MSICCodeID
                                  ? 'MSIC Code is required'
                                  : null
                              }
                              error={
                                !!watch('isSelfBilled') && errors?.MSICCodeID
                                  ? true
                                  : false
                              }
                              label="MSIC Code"
                              style={{ width: '100%' }}
                              InputLabelProps={defVal ? { shrink: true } : null}
                              margin="dense"
                              variant="standard"
                              required={!!watch('isSelfBilled') ? true : false}
                            />
                          </div>
                        )
                      }}
                    />
                  )
                }}
                label="MSIC Code"
                name="MSICCodeID"
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                margin="dense"
                ref={register}
                helperText={
                  !!watch('isSelfBilled') ? errors?.MSICCodeID?.message : null
                }
                error={
                  !!watch('isSelfBilled') && errors?.MSICCodeID ? true : false
                }
                defaultValue={editData ? editData?.einvoice_msic_code_id : ''}
              />
            )}
          </CardContents>
        )}

        <CardContents section={{ header: { title: 'Address Info' } }}>
          <AddressAutoComponent
            getCountry={getCountry}
            getStatebyCountry={getStatebyCountry}
            getCitybyState={getCitybyState}
            getPostcodebyCity={getPostcodebyCity}
            handleCountryOnChange={handleCountryOnChange}
            handleStateOnChange={handleStateOnChange}
            handleCityOnChange={handleCityOnChange}
            handlePostCodeOnChange={handlePostCodeOnChange}
            handleGoogleOnChange={handleGoogleOnChange}
            autoCompleteRef={autoCompleteRef}
            state={state}
            country={country}
            states={states} // for address States, not global state. Please don't remove
            city={city}
            postcode={postcode}
            setCountry={setCountry}
            setStates={setStates}
            setCity={setCity}
            setPostcode={setPostcode}
          />
        </CardContents>
        <CardContents
          section={{
            header: {
              title: 'Contact Details',
              onClickAction: () => {
                resetMenu()
                setOpenDialog(true)
              },
              icon: (
                <AddIcon
                  htmlColor="white"
                  fontSize="small"
                  style={{
                    width: '20px',
                    height: '20px',
                    margin: '0',
                    background: theme.palette.primary.main,
                    borderRadius: '3px',
                    color: 'rgba(224,234,254,100)',
                    marginTop: '10px',
                    marginRight: '10px',
                  }}
                />
              ),
            },
          }}
        >
          {contactData?.length === 0 ? (
            <div
              style={{
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <EmptyList
                title="No Contact Record(s)"
                subtitle="Click on the plus button to add records"
              />
            </div>
          ) : (
            contactData?.map((el, index) => {
              return (
                <List style={{ width: '100%', paddingBottom: '0px' }}>
                  <ListItem
                    key={index}
                    onClick={() =>
                      history.push({
                        pathname: el.path,
                      })
                    }
                    style={{ marginLeft: '-5px', marginTop: '-15px' }}
                  >
                    <ListItemText
                      primary={
                        <>
                          <span className="desc xsTitle">
                            {el.name} ({el.designation})
                          </span>

                          <span style={{ verticalAlign: 'middle' }}>
                            {el?.isDefault === true && (
                              <span className="desc">
                                <CheckCircleIcon
                                  style={{
                                    color: 'limegreen',
                                    fontSize: 'medium',
                                  }}
                                />
                              </span>
                            )}
                          </span>
                        </>
                      }
                      secondary={
                        <span className="desc">
                          {!!el?.phoneNo ? (
                            <span>
                              <PhoneIcon
                                style={{
                                  fontSize: '10px',
                                  color: 'black',
                                  marginBottom: '-1px',
                                  marginRight: '3px',
                                }}
                              />

                              <span
                                className={` primary-click-text`}
                                onClick={e => {
                                  window.open(`tel:${el.phoneNo}`)
                                }}
                              >
                                +{el.phoneNo}
                              </span>
                            </span>
                          ) : null}
                          {!!el?.email ? (
                            <>
                              {` | `}
                              <span>
                                <EmailIcon
                                  style={{
                                    fontSize: '12px',
                                    color: 'black',
                                    marginBottom: '-3px',
                                    marginRight: '3px',
                                  }}
                                />
                                <span
                                  className={` primary-click-text`}
                                  onClick={e => {
                                    window.open(`mailto:${el.email}`)
                                  }}
                                >
                                  {el.email}
                                </span>
                              </span>
                            </>
                          ) : null}
                        </span>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={e => {
                          handleClick(e, el.id, index, el)
                          setOpenDialog(true)
                        }}
                      >
                        <CreateIcon
                          htmlColor="white"
                          fontSize="small"
                          style={{
                            width: '20px',
                            height: '20px',
                            margin: '-7px',
                            background: theme.palette.primary.main,
                            borderRadius: '3px',
                            color: 'rgba(224,234,254,100)',
                          }}
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              )
            })
          )}
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Director Details',
              onClickAction: () => {
                resetMenu()
                setOpenDirectorDialog(true)
              },
              icon: (
                <AddIcon
                  htmlColor="white"
                  fontSize="small"
                  style={{
                    width: '20px',
                    height: '20px',
                    margin: '0',
                    background: theme.palette.primary.main,
                    borderRadius: '3px',
                    color: 'rgba(224,234,254,100)',
                    marginTop: '10px',
                    marginRight: '10px',
                  }}
                />
              ),
            },
          }}
        >
          {directorData?.length === 0 ? (
            <div
              style={{
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <EmptyList
                title="No Director Record(s)"
                subtitle="Click on the plus button to add records"
              />
            </div>
          ) : (
            directorData.map((el, index) => {
              return (
                <List style={{ width: '100%', paddingBottom: '0px' }}>
                  <ListItem
                    key={index}
                    onClick={() =>
                      history.push({
                        pathname: el.path,
                      })
                    }
                    style={{ marginLeft: '-5px', marginTop: '-15px' }}
                  >
                    <ListItemText
                      primary={<span className="desc xsTitle">{el.name}</span>}
                      secondary={
                        <span className="desc">
                          <span>
                            <PhoneIcon
                              style={{
                                fontSize: '10px',
                                color: 'black',
                                marginBottom: '-1px',
                                marginRight: '3px',
                              }}
                            />

                            <span
                              className={` primary-click-text`}
                              onClick={e => {
                                window.open(`tel:${el.phoneNo}`)
                              }}
                            >
                              +{el.phoneNo}
                            </span>
                          </span>
                          {` | `}
                          <span>
                            <EmailIcon
                              style={{
                                fontSize: '12px',
                                color: 'black',
                                marginBottom: '-3px',
                                marginRight: '3px',
                              }}
                            />
                            <span
                              className={` primary-click-text`}
                              onClick={e => {
                                window.open(`mailto:${el.email}`)
                              }}
                            >
                              {el.email}
                            </span>
                          </span>
                        </span>
                      }
                    />

                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={e => {
                          handleClick(e, el.id, index, el)
                          setOpenDirectorDialog(true)
                        }}
                      >
                        <CreateIcon
                          htmlColor="white"
                          fontSize="small"
                          style={{
                            width: '20px',
                            height: '20px',
                            margin: '-7px',
                            background: theme.palette.primary.main,
                            borderRadius: '3px',
                            color: 'rgba(224,234,254,100)',
                          }}
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              )
            })
          )}
        </CardContents>
      </ContentWrapper>

      <Footer
        options={[
          {
            name: 'Save',
            color: 'primary',
            disabled: isDirectSend === true && isInvalid === true,
            onClick: e => {
              if (checkDuplicateCompanyName()) {
                return
              }
              const email = watch('email')
              const isEmailEmpty =
                email === '' || email === null || email === undefined

              if (isEmailEmpty || validateEmail(email)) {
                handleSubmit(data =>
                  onSubmit(data, state, contactData, directorData)
                )()
              }
            },
          },
        ]}
      />
      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
          setCheckContactError([])
        }}
        sections={{
          header: {
            title: 'Contact Details',
            rightText: !!menu?.obj ? 'Edit' : 'New',
            infoLine: menu?.obj?.name,
          },
          body: () => (
            <CardContents>
              <Controller
                as={TextField}
                name="Contact.contactName"
                label="Name"
                required
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                helperText={
                  (watch('Contact.contactName') === '' ||
                    watch('Contact.contactName') === undefined) &&
                  checkContactError?.find(x => x?.error === 'contactName')
                    ? 'Name is required'
                    : null
                }
                error={
                  (watch('Contact.contactName') === '' ||
                    watch('Contact.contactName') === undefined) &&
                  checkContactError?.find(x => x?.error === 'contactName')
                    ? true
                    : false
                }
                ref={register}
                defaultValue={menu?.obj?.name || ''}
              />

              <Controller
                as={TextField}
                name="Contact.designation"
                label="Designation"
                required
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                helperText={
                  (watch('Contact.designation') === '' ||
                    watch('Contact.designation') === undefined) &&
                  checkContactError?.find(x => x?.error === 'designation')
                    ? 'Designation is required'
                    : null
                }
                error={
                  (watch('Contact.designation') === '' ||
                    watch('Contact.designation') === undefined) &&
                  checkContactError?.find(x => x?.error === 'designation')
                    ? true
                    : false
                }
                ref={register}
                defaultValue={menu?.obj?.designation || ''}
              />

              <Controller
                as={
                  <PhoneNumInput
                    country={user?.countryCode ?? 'my'}
                    specialLabel="Mobile No."
                    fullWidth
                  />
                }
                name="Contact.mobileNo"
                type="tel"
                marginTop
                marginBottom
                // helperText={
                //   (watch('Contact.mobileNo') === '' ||
                //     watch('Contact.mobileNo') === undefined) &&
                //   checkContactError?.find(x => x?.error === 'mobileNo')
                //     ? 'Mobile No is required'
                //     : null
                // }
                // error={
                //   (watch('Contact.mobileNo') === '' ||
                //     watch('Contact.mobileNo') === undefined) &&
                //   checkContactError?.find(x => x?.error === 'mobileNo')
                //     ? true
                //     : false
                // }
                margin="dense"
                control={control}
                ref={register}
                defaultValue={menu?.obj?.phoneNo || ''}
              />

              <Controller
                as={TextField}
                name="Contact.emailAddress"
                label="Email Address"
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                type="email"
                helperText={
                  !!watch('Contact.emailAddress') &&
                  validateEmail(watch('Contact.emailAddress')) === false
                    ? 'Email must be a valid email'
                    : null
                }
                error={
                  !!watch('Contact.emailAddress') &&
                  validateEmail(watch('Contact.emailAddress')) === false
                    ? true
                    : false
                }
                ref={register}
                defaultValue={menu?.obj?.email || ''}
              />

              <Controller
                as={
                  <FormControlLabel
                    style={{ fontWeight: 'bold' }}
                    control={
                      <Checkbox
                        defaultChecked={
                          menu?.obj?.isDefault == true ? true : false
                        }
                        name={'Contact.isDefault'}
                        color="primary"
                        ref={register}
                        onChange={e => {
                          setValue('Contact.isDefault', e.target.checked)
                        }}
                      />
                    }
                    label={'Set Default'}
                  />
                }
                name={'Contact.isDefault'}
                ref={register}
                control={control}
                defaultValue={menu?.obj?.isDefault == true ? true : false}
              />
            </CardContents>
          ),
          leftFooterIcon: menu?.obj ? (
            <span style={{ width: '100%' }}>
              <IconButton
                edge="start"
                style={{
                  color: 'black',
                  marginTop: '-20px',
                  marginBottom: '-15px',
                }}
                onClick={e => {
                  onDeleteContact(menu?.index)
                  setOpenDialog(false)
                }}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          ) : null,
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    isDirty ? setOpenExitConf(true) : setCheckContactError([])
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    menu?.obj
                      ? onUpdateContact(watch('Contact'), menu?.index)
                      : onCreateContact(watch('Contact'))
                    checkContact(watch('Contact'))?.length === 0
                      ? setOpenDialog(false)
                      : setOpenDialog(true)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <CommonDialog
        fullWidth={true}
        open={openDirectorDialog}
        onClose={() => {
          setOpenDirectorDialog(false)
          setCheckDirectorError([])
        }}
        sections={{
          header: {
            title: 'Director Details',
            rightText: !!menu?.obj ? 'Edit' : 'New',
            infoLine: menu?.obj?.name,
          },
          body: () => (
            <CardContents>
              <Controller
                as={TextField}
                id="standard-basic"
                name="Director.identityNo"
                label="Identity No"
                autoComplete="off"
                control={control}
                fullWidth
                margin="dense"
                ref={register}
                defaultValue={menu?.obj?.identityNo || ''}
                className="left"
              />
              <Controller
                render={({ onChange, value }) => (
                  <TextField
                    select
                    name="Director.identityType"
                    label="Identity Type"
                    className="right"
                    style={{ marginTop: '5px' }}
                    value={value}
                    onChange={e => {
                      setValue('Director.identityType', e?.target?.value)
                    }}
                  >
                    {IdentityType?.map((el, index) => (
                      <MenuItem key={index} value={el.type}>
                        {`${el.name}`}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                name="Director.identityType"
                label="Identity Type"
                autoComplete="off"
                onChange={e =>
                  setValue('Director.identityType', e?.target?.value)
                }
                control={control}
                multiline={true}
                fullWidth
                ref={register()}
                select
                className="right"
                defaultValue={menu?.obj?.identityType || null}
              />
              <Controller
                as={TextField}
                name="Director.contactName"
                label="Name"
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                ref={register}
                defaultValue={menu?.obj?.name || ''}
              />

              <Controller
                as={
                  <PhoneNumInput
                    country={user?.countryCode ?? 'my'}
                    specialLabel="Mobile No."
                    fullWidth
                  />
                }
                name="Director.mobileNo"
                type="tel"
                marginTop
                marginBottom
                // helperText={
                //   (watch('Director.mobileNo') === '' ||
                //     watch('Director.mobileNo') === undefined) &&
                //   checkDirectorError?.find(x => x?.error === 'mobileNo')
                //     ? 'Mobile No is required'
                //     : null
                // }
                // error={
                //   (watch('Director.mobileNo') === '' ||
                //     watch('Director.mobileNo') === undefined) &&
                //   checkDirectorError?.find(x => x?.error === 'mobileNo')
                //     ? true
                //     : false
                // }
                margin="dense"
                control={control}
                ref={register}
                defaultValue={menu?.obj?.phoneNo || ''}
              />

              <Controller
                as={TextField}
                name="Director.emailAddress"
                label="Email Address"
                autoComplete="off"
                control={control}
                multiline={true}
                fullWidth
                ref={register}
                defaultValue={menu?.obj?.email || ''}
              />
            </CardContents>
          ),
          leftFooterIcon: menu?.obj ? (
            <span style={{ width: '100%' }}>
              <IconButton
                edge="start"
                style={{
                  color: 'black',
                  marginTop: '-20px',
                  marginBottom: '-15px',
                }}
                onClick={e => {
                  onDeleteDirector(menu?.index)
                  setOpenDirectorDialog(false)
                }}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          ) : null,
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    isDirty ? setOpenExitConf(true) : setCheckDirectorError([])
                    setOpenDirectorDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    menu?.obj
                      ? onUpdateDirector(menu?.index, watch('Director'))
                      : onCreateDirector(watch('Director'))
                    checkDirector(watch('Director'))?.length === 0
                      ? setOpenDirectorDialog(false)
                      : setOpenDirectorDialog(true)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          setOpenExitConf(false)
          mode === 'add'
            ? history.push(
                `/account-payable/general-setting/creditor-profile/${creditorType}`
              )
            : history.push({
                pathname: `/account-payable/general-setting/creditor-profile/${creditorType}/${CreditorAccountID}/detail`,
              })
        }}
      />

      <ErrorDialog
        errorMsg={errMsg}
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
